import { useEffect, useState } from "react";
import { useFetchRecentClientsListQuery } from "../../../services/auditlogs";

const useFetchRecentClients = (initialPage = 1, initialLimit = 7) => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(initialPage);
    const [limit, setLimit] = useState(initialLimit);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const { data: response, isError, isFetching, isLoading, isUninitialized, refetch } = useFetchRecentClientsListQuery({ page, limit });

    const nextPage = () => {
        setPage(curr => curr + 1);
    };

    const previousPage = () => {
        setPage(curr => curr - 1);
    };

    const reload = (e) => {
        if (e && typeof (e.preventDefault) === 'function') {
            e.preventDefault();
        }
        if (page > 1) {
            setPage(_ => 1);
        }
        else {
            refetch();
        }
    };

    useEffect(() => {
        if (!response) {
            return;
        }
        
        const { pagination, results } = response || {};
        const { totalCount: responseTotalCount, totalPages: responseTotalPages } = pagination || {};
        setData(results);
        setTotalCount(responseTotalCount);
        setTotalPages(responseTotalPages);
    }, [ response ]);

    return {
        data,
        isError,
        isLoading: isFetching === true || isLoading === true,
        isUninitialized,
        limit,
        nextPage,
        page,
        previousPage,
        reload,
        setLimit,
        setPage,
        totalCount,
        totalPages
    }
};

export default useFetchRecentClients;